import { FieldDictionary } from '@shopify/react-form';
import gettext, { pgettext } from '@sdk/lang/gettext';
import TimePicker from '@sdk/components/forms/TimePicker';

import { TimeClockEntry } from '@web/timesheets/CreateTimesheetModal/createTimesheetModal.types';
import ModalRow from '@web/timesheets/CreateTimesheetModal/components/rows/ModalRow/ModalRow';
import { FieldContainer } from '@web/timesheets/CreateTimesheetModal/components/rows/ModalRow/modalRow.styles';
import RemoveEntryButton from '@web/timesheets/CreateTimesheetModal/components/buttons/RemoveEntryButton';
import { TimePickersRow } from '@web/timesheets/CreateTimesheetModal/components/rows/rows.styles';
import TimeIconSvg from '@web/assets/svg/Icons/32/time-gray.svg';
import { DEFAULT_INTERVAL_IN_MINUTES_FOR_TIME_PICKERS } from '@web/timeClock/constants';
import { useTimeClockRow } from '@web/timesheets/CreateTimesheetModal/components/rows/TimeClockRow/timeClockRow.hooks';
import { StartDateWithLocalTime } from '@web/timesheets/EditTimesheetModal/editTimesheetModal.types';

type Props = {
  timeClockFieldSet: FieldDictionary<TimeClockEntry>;
  isRemovable: boolean;
  remove: VoidFunction;
  scheduledShiftStart?: StartDateWithLocalTime;
};
const TimeClockRow = ({ timeClockFieldSet, isRemovable, remove, scheduledShiftStart }: Props) => {
  const intervalInMinutes = DEFAULT_INTERVAL_IN_MINUTES_FOR_TIME_PICKERS;
  const { onClockInChange, usTimeFormat, clockInStartHour, clockOutStartHour } = useTimeClockRow({
    timeClockFieldSet,
    intervalInMinutes,
    scheduledShiftStart,
  });

  return (
    <ModalRow label={gettext('Time clock')} icon={TimeIconSvg}>
      <FieldContainer>
        <TimePickersRow>
          <TimePicker
            onChange={onClockInChange}
            prefix={pgettext('specifing clock in time period i.e. in 9 out 5', 'In')}
            value={timeClockFieldSet.clockIn.value}
            intervalInMinutes={intervalInMinutes}
            usTimeFormat={usTimeFormat}
            startHour={clockInStartHour}
            invalid={Boolean(timeClockFieldSet.clockIn.error?.length)}
          />

          <TimePicker
            onChange={timeClockFieldSet.clockOut.onChange}
            prefix={pgettext('specifing clock in time period i.e. in 9 out 5', 'Out')}
            value={timeClockFieldSet.clockOut.value}
            intervalInMinutes={intervalInMinutes}
            usTimeFormat={usTimeFormat}
            startHour={clockOutStartHour}
            timeDifferenceBase={timeClockFieldSet.clockIn.value}
            invalid={Boolean(timeClockFieldSet.clockOut.error?.length)}
          />

          {isRemovable && <RemoveEntryButton onClick={remove} />}
        </TimePickersRow>
      </FieldContainer>
    </ModalRow>
  );
};

export default TimeClockRow;
